import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PhotoCredit from '../components/PhotoCredit';
import { getImagePhotographer } from '../config/cloudinaryConfig';
import SEO from '../components/SEO';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';
import PhotoSwipeDynamicCaption from 'photoswipe-dynamic-caption-plugin';
import 'photoswipe-dynamic-caption-plugin/photoswipe-dynamic-caption-plugin.css';

const Birdwatching = () => {
  const { t } = useTranslation();

  const galleryImages = useMemo(() => [
    {
      largeURL: 'https://res.cloudinary.com/dxlhv2mji/image/upload/f_auto,q_auto,w_auto,c_scale/v1738450243/tie_bicudo_jh_hfnk4c.jpg',
      thumbnailURL: 'https://res.cloudinary.com/dxlhv2mji/image/upload/f_auto,q_auto,w_400,c_thumb,g_auto/v1738450243/tie_bicudo_jh_hfnk4c.jpg',
      srcset: 'https://res.cloudinary.com/dxlhv2mji/image/upload/f_auto,q_auto,w_auto,c_scale/v1738450243/tie_bicudo_jh_hfnk4c.jpg',
      sizes: '(max-width: 800px) 100vw, (max-width: 1200px) 80vw, (max-width: 1600px) 70vw, 60vw',
      width: 740,
      height: 683,
      photographer: getImagePhotographer('birdwatching', 'tie-bicudo'),
      title: t('birdwatching.registeredBirds.species.tieBicudo.name'),
      type: 'image',
      alt: t('birdwatching.registeredBirds.species.tieBicudo.name'),
      description: t('birdwatching.gallery.descriptions.tieBicudo')
    },
    {
      largeURL: 'https://res.cloudinary.com/dxlhv2mji/image/upload/f_auto,q_auto,w_auto,c_scale/v1736085702/curica_enlrcd.jpg',
      thumbnailURL: 'https://res.cloudinary.com/dxlhv2mji/image/upload/f_auto,q_auto,w_400,c_thumb,g_auto/v1736085702/curica_enlrcd.jpg',
      srcset: 'https://res.cloudinary.com/dxlhv2mji/image/upload/f_auto,q_auto,w_auto,c_scale/v1747773403/curica_perfil_qbdgzy.jpg',
      sizes: '(max-width: 800px) 100vw, (max-width: 1200px) 80vw, (max-width: 1600px) 70vw, 60vw',
      width: 1600,
      height: 1464,
      photographer: getImagePhotographer('birdwatching', 'curica'),
      title: t('birdwatching.registeredBirds.species.curica.name'),
      type: 'image',
      alt: t('birdwatching.registeredBirds.species.curica.name'),
      description: t('birdwatching.gallery.descriptions.curica')
    },
    {
      largeURL: 'https://res.cloudinary.com/dxlhv2mji/image/upload/f_auto,q_auto,w_auto,c_scale/v1738450271/MANOEL_RUEDI_70_ierwkw.jpg',
      thumbnailURL: 'https://res.cloudinary.com/dxlhv2mji/image/upload/f_auto,q_auto,w_400,c_thumb,g_auto/v1738450271/MANOEL_RUEDI_70_ierwkw.jpg',
      srcset: 'https://res.cloudinary.com/dxlhv2mji/image/upload/f_auto,q_auto,w_auto,c_scale/v1738450271/MANOEL_RUEDI_70_ierwkw.jpg',
      sizes: '(max-width: 800px) 100vw, (max-width: 1200px) 80vw, (max-width: 1600px) 70vw, 60vw',
      width: 2203,
      height: 1294,
      photographer: getImagePhotographer('birdwatching', 'anambe preto'),
      title: t('birdwatching.registeredBirds.species.umbrellaBird.name'),
      type: 'image',
      alt: t('birdwatching.registeredBirds.species.umbrellaBird.name'),
      description: t('birdwatching.gallery.descriptions.umbrellaBird')
    },
    {
      largeURL: 'https://res.cloudinary.com/dxlhv2mji/image/upload/f_auto,q_auto,w_auto,c_scale/v1738450244/beija_flor_tesoura_verde_JHONATA_ARAUJO_2_xk7oou.jpg',
      thumbnailURL: 'https://res.cloudinary.com/dxlhv2mji/image/upload/f_auto,q_auto,w_400,c_thumb,g_auto/v1738450244/beija_flor_tesoura_verde_JHONATA_ARAUJO_2_xk7oou.jpg',
      srcset: 'https://res.cloudinary.com/dxlhv2mji/image/upload/f_auto,q_auto,w_auto,c_scale/v1738450244/beija_flor_tesoura_verde_JHONATA_ARAUJO_2_xk7oou.jpg',
      sizes: '(max-width: 800px) 100vw, (max-width: 1200px) 80vw, (max-width: 1600px) 70vw, 60vw',
      width: 1600,
      height: 1600,
      photographer: 'Jhonata Araujo',
      title: t('birdwatching.gallery.images.hummingbird'),
      type: 'image',
      alt: t('birdwatching.gallery.images.hummingbird'),
      description: t('birdwatching.gallery.descriptions.hummingbird')
    },
    {
      largeURL: 'https://res.cloudinary.com/dxlhv2mji/image/upload/f_auto,q_auto,w_auto,c_scale/v1738450280/choca_dagua_-_JHONATA_ARAUJO_7_q86nhg.jpg',
      thumbnailURL: 'https://res.cloudinary.com/dxlhv2mji/image/upload/f_auto,q_auto,w_400,c_thumb,g_auto/v1738450280/choca_dagua_-_JHONATA_ARAUJO_7_q86nhg.jpg',
      srcset: 'https://res.cloudinary.com/dxlhv2mji/image/upload/f_auto,q_auto,w_auto,c_scale/v1738450280/choca_dagua_-_JHONATA_ARAUJO_7_q86nhg.jpg',
      sizes: '(max-width: 800px) 100vw, (max-width: 1200px) 80vw, (max-width: 1600px) 70vw, 60vw',
      width: 1920,
      height: 1280,
      photographer: 'Jhonata Araujo',
      title: t('birdwatching.gallery.images.waterThrush'),
      type: 'image',
      alt: t('birdwatching.gallery.images.waterThrush'),
      description: t('birdwatching.gallery.descriptions.waterThrush')
    },
    {
      largeURL: 'https://res.cloudinary.com/dxlhv2mji/image/upload/f_auto,q_auto,w_auto,c_scale/v1738450277/MARACANA_DO_BURITI-_JHONATA_ARAUJO_10_ur2fgl.jpg',
      thumbnailURL: 'https://res.cloudinary.com/dxlhv2mji/image/upload/f_auto,q_auto,w_400,c_thumb,g_auto/v1738450277/MARACANA_DO_BURITI-_JHONATA_ARAUJO_10_ur2fgl.jpg',
      srcset: 'https://res.cloudinary.com/dxlhv2mji/image/upload/f_auto,q_auto,w_auto,c_scale/v1738450277/MARACANA_DO_BURITI-_JHONATA_ARAUJO_10_ur2fgl.jpg',
      sizes: '(max-width: 800px) 100vw, (max-width: 1200px) 80vw, (max-width: 1600px) 70vw, 60vw',
      width: 1920,
      height: 1280,
      photographer: 'Jhonata Araujo',
      title: t('birdwatching.gallery.images.buritiMacaw'),
      type: 'image',
      alt: t('birdwatching.gallery.images.buritiMacaw'),
      description: t('birdwatching.gallery.descriptions.buritiMacaw')
    },
    {
      largeURL: 'https://res.cloudinary.com/dxlhv2mji/image/upload/f_auto,q_auto,w_auto,c_scale/v1738450239/saira_de_cabeça_azul_-Vincent_Kurt_lo_1_z5hik4.jpg',
      thumbnailURL: 'https://res.cloudinary.com/dxlhv2mji/image/upload/f_auto,q_auto,w_400,c_thumb,g_auto/v1738450239/saira_de_cabeça_azul_-Vincent_Kurt_lo_1_z5hik4.jpg',
      srcset: 'https://res.cloudinary.com/dxlhv2mji/image/upload/f_auto,q_auto,w_auto,c_scale/v1738450239/saira_de_cabeça_azul_-Vincent_Kurt_lo_1_z5hik4.jpg',
      sizes: '(max-width: 800px) 100vw, (max-width: 1200px) 80vw, (max-width: 1600px) 70vw, 60vw',
      width: 1280,
      height: 995,
      photographer: 'Vincent Kurt Lo',
      title: t('birdwatching.gallery.images.blueTanager'),
      type: 'image',
      alt: t('birdwatching.gallery.images.blueTanager'),
      description: t('birdwatching.gallery.descriptions.blueTanager')
    },
    {
      largeURL: 'https://res.cloudinary.com/dxlhv2mji/image/upload/f_auto,q_auto,w_auto,c_scale/v1747692351/gaviao_real_qreotx.jpg',
      thumbnailURL: 'https://res.cloudinary.com/dxlhv2mji/image/upload/f_auto,q_auto,w_400,c_thumb,g_auto/v1747692351/gaviao_real_qreotx.jpg',
      srcset: 'https://res.cloudinary.com/dxlhv2mji/image/upload/f_auto,q_auto,w_auto,c_scale/v1747692351/gaviao_real_qreotx.jpg',
      sizes: '(max-width: 800px) 100vw, (max-width: 1200px) 80vw, (max-width: 1600px) 70vw, 60vw',
      width: 755,
      height: 755,
      photographer: 'Jhonata Araujo',
      title: t('birdwatching.gallery.images.harpia'),
      type: 'image',
      alt: t('birdwatching.gallery.images.harpia'),
      description: t('birdwatching.gallery.descriptions.harpia')
    },
    {
      largeURL: 'https://res.cloudinary.com/dxlhv2mji/image/upload/f_auto,q_auto,w_auto,c_scale/v1738450390/MANOEL_RUEDI_121_pvdynq.jpg',
      thumbnailURL: 'https://res.cloudinary.com/dxlhv2mji/image/upload/f_auto,q_auto,w_400,c_thumb,g_auto/v1738450390/MANOEL_RUEDI_121_pvdynq.jpg',
      srcset: 'https://res.cloudinary.com/dxlhv2mji/image/upload/f_auto,q_auto,w_auto,c_scale/v1738450390/MANOEL_RUEDI_121_pvdynq.jpg',
      sizes: '(max-width: 800px) 100vw, (max-width: 1200px) 80vw, (max-width: 1600px) 70vw, 60vw',
      width: 1920,
      height: 1280,
      photographer: 'Manoel Ruedi',
      title: t('birdwatching.gallery.images.pygmyOwl'),
      type: 'image',
      alt: t('birdwatching.gallery.images.pygmyOwl'),
      description: t('birdwatching.gallery.descriptions.pygmyOwl')
    },
    {
      largeURL: 'https://res.cloudinary.com/dxlhv2mji/image/upload/f_auto,q_auto,w_auto,c_scale/v1738450241/hypoedaleus%20guttatus_ilemhy.jpg',
      thumbnailURL: 'https://res.cloudinary.com/dxlhv2mji/image/upload/f_auto,q_auto,w_400,c_thumb,g_auto/v1738450241/hypoedaleus%20guttatus_ilemhy.jpg',
      srcset: 'https://res.cloudinary.com/dxlhv2mji/image/upload/f_auto,q_auto,w_auto,c_scale/v1738450241/hypoedaleus%20guttatus_ilemhy.jpg',
      sizes: '(max-width: 800px) 100vw, (max-width: 1200px) 80vw, (max-width: 1600px) 70vw, 60vw',
      width: 1920,
      height: 1280,
      photographer: 'Manoel Ruedi',
      title: t('birdwatching.gallery.images.blackGirdledBarbet'),
      type: 'image',
      alt: t('birdwatching.gallery.images.blackGirdledBarbet'),
      description: t('birdwatching.gallery.descriptions.blackGirdledBarbet')
    }
  ], [t]);

  useEffect(() => {
    const dataSource = galleryImages.map(item => {
      if (item.type === 'video') {
        return {
          html: item.html,
          width: item.width,
          height: item.height,
          title: `${item.title} - ${item.photographer}`,
          alt: item.alt
        };
      }
      return {
        src: item.largeURL,
        srcset: item.srcset,
        sizes: item.sizes,
        width: item.width,
        height: item.height,
        title: `${item.title} - ${item.photographer}`,
        alt: item.alt
      };
    });

    const lightbox = new PhotoSwipeLightbox({
      dataSource: dataSource,
      pswpModule: () => import('photoswipe'),
      gallery: '#birdwatching-gallery',
      children: 'a',
      showHideAnimationType: 'fade',
      showAnimationDuration: 300,
      hideAnimationDuration: 300,
      zoomAnimationDuration: 300,
      easing: 'cubic-bezier(0.4, 0, 0.22, 1)',
      initialZoomLevel: 'fit',
      secondaryZoomLevel: 2,
      maxZoomLevel: 4,
      imageClickAction: 'zoom',
      tapAction: 'zoom',
      doubleTapAction: 'zoom',
      indexIndicatorSep: ' / ',
      preloaderDelay: 2000,
      errorMsg: '<div class="pswp__error-msg">Image not found</div>'
    });

    // Initialize dynamic caption plugin
    new PhotoSwipeDynamicCaption(lightbox, {
      type: 'auto',
      captionContent: (slide) => {
        const el = slide.data.element;
        if (el) {
          const captionEl = el.querySelector('.pswp-caption-content');
          if (captionEl) return captionEl.innerHTML;
        }
        return slide.data.alt || '';
      }
    });

    lightbox.init();

    return () => {
      lightbox.destroy();
    };
  }, [galleryImages]);

  return (
    <>
      <SEO 
        title={t('meta.birdwatching.title')}
        description={t('meta.birdwatching.description')}
        keywords={t('meta.birdwatching.keywords')}
        image="https://res.cloudinary.com/dxlhv2mji/image/upload/v1738450243/tie_bicudo_jh_hfnk4c.jpg"
      />
      <div className="min-h-screen bg-white">
        {/* Hero Section */}
        <div 
          className="relative h-[70vh] flex items-center justify-center text-center text-white mb-16"
          style={{
            backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url('${galleryImages[0].largeURL}')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
           {/* Overlay */}
          <div className="absolute inset-0 bg-black/60 z-10" />

          {/* Content */}
          <div className="relative z-20 px-4">
            <h1 className="text-4xl md:text-6xl font-normal mb-4 tracking-wider drop-shadow-lg">
              {t('birdwatching.hero.title')}
            </h1>
            <p className="text-xl md:text-2xl font-light italic max-w-3xl mx-auto">
              {t('birdwatching.hero.subtitle')}
            </p>
          </div>
          <PhotoCredit photographer={galleryImages[0].photographer} />
        </div>

        {/* Intro Section */}
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4 max-w-4xl">
            <p className="text-xl text-gray-700 leading-relaxed text-justify">
              {t('birdwatching.intro.description')}
            </p>
          </div>
        </section>

        {/* Recognition Stats Section */}
        <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-4">
            <h2 className="text-4xl font-semibold text-center mb-16 relative">
              {t('birdwatching.recognition.title')}
              <span className="absolute bottom-[-1rem] left-1/2 transform -translate-x-1/2 w-20 h-1 bg-primary" />
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
              <div className="bg-white p-8 rounded-xl shadow-lg text-center">
                <h3 className="text-4xl font-bold text-primary mb-4">{t('birdwatching.recognition.stats.brazil.number')}</h3>
                <p className="text-gray-600">{t('birdwatching.recognition.stats.brazil.label')}</p>
              </div>
              <div className="bg-white p-8 rounded-xl shadow-lg text-center">
                <h3 className="text-4xl font-bold text-primary mb-4">{t('birdwatching.recognition.stats.matoGrosso.number')}</h3>
                <p className="text-gray-600">{t('birdwatching.recognition.stats.matoGrosso.label')}</p>
              </div>
              <div className="bg-white p-8 rounded-xl shadow-lg text-center">
                <h3 className="text-4xl font-bold text-primary mb-4">{t('birdwatching.recognition.stats.species.number')}</h3>
                <p className="text-gray-600">{t('birdwatching.recognition.stats.species.label')}</p>
              </div>
            </div>
          </div>
        </section>

        {/* Registered Birds Section */}
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <h2 className="text-4xl font-semibold text-center mb-16 relative">
              {t('birdwatching.registeredBirds.title')}
              <span className="absolute bottom-[-1rem] left-1/2 transform -translate-x-1/2 w-20 h-1 bg-primary" />
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {/* Criticamente em Perigo (CR) */}
              <div className="bg-white rounded-xl shadow-lg overflow-hidden transition-transform duration-300 hover:-translate-y-2">
                <div className="flex flex-col md:flex-row h-48">
                  <div className="md:w-1/3 relative h-full">
                    <img 
                      src={galleryImages[0].largeURL}
                      alt={t('birdwatching.registeredBirds.species.tieBicudo.name')}
                      className="w-full h-full object-cover"
                    />
                    <span className="absolute top-4 right-4 px-2 py-1 text-xs font-semibold text-white bg-red-600 rounded">
                      {t('birdwatching.conservationStatus.cr').split(' - ')[0]}
                    </span>
                    <PhotoCredit photographer={galleryImages[0].photographer} />
                  </div>
                  <div className="md:w-2/3 p-6 flex flex-col justify-center">
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">{t('birdwatching.registeredBirds.species.tieBicudo.name')}</h3>
                    <p className="text-sm text-primary italic mb-2">{t('birdwatching.registeredBirds.species.tieBicudo.scientificName')}</p>
                    <p className="text-gray-600 text-sm leading-relaxed line-clamp-2 text-justify">
                      {t('birdwatching.registeredBirds.species.tieBicudo.description')}
                    </p>
                  </div>
                </div>
              </div>

              {/* Quase Ameaçada (NT) */}
              <div className="bg-white rounded-xl shadow-lg overflow-hidden transition-transform duration-300 hover:-translate-y-2">
                <div className="flex flex-col md:flex-row h-48">
                  <div className="md:w-1/3 relative h-full">
                    <img 
                      src={galleryImages[1].largeURL}
                      alt={t('birdwatching.registeredBirds.species.curica.name')}
                      className="w-full h-full object-cover"
                    />
                    <span className="absolute top-4 right-4 px-2 py-1 text-xs font-semibold text-white bg-yellow-600 rounded">
                      {t('birdwatching.conservationStatus.nt').split(' - ')[0]}
                    </span>
                    <PhotoCredit photographer={galleryImages[1].photographer} />
                  </div>
                  <div className="md:w-2/3 p-6 flex flex-col justify-center">
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">{t('birdwatching.registeredBirds.species.curica.name')}</h3>
                    <p className="text-sm text-primary italic mb-2">{t('birdwatching.registeredBirds.species.curica.scientificName')}</p>
                    <p className="text-gray-600 text-sm leading-relaxed line-clamp-2 text-justify">
                      {t('birdwatching.registeredBirds.species.curica.description')}
                    </p>
                  </div>
                </div>
              </div>

              {/* Pouco Preocupante (LC) */}
              <div className="bg-white rounded-xl shadow-lg overflow-hidden transition-transform duration-300 hover:-translate-y-2">
                <div className="flex flex-col md:flex-row h-48">
                  <div className="md:w-1/3 relative h-full">
                    <img 
                      src={galleryImages[2].largeURL}
                      alt={t('birdwatching.registeredBirds.species.umbrellaBird.name')}
                      className="w-full h-full object-cover"
                    />
                    <span className="absolute top-4 right-4 px-2 py-1 text-xs font-semibold text-white bg-green-600 rounded">
                      {t('birdwatching.conservationStatus.lc').split(' - ')[0]}
                    </span>
                    <PhotoCredit photographer={galleryImages[2].photographer} />
                  </div>
                  <div className="md:w-2/3 p-6 flex flex-col justify-center">
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">{t('birdwatching.registeredBirds.species.umbrellaBird.name')}</h3>
                    <p className="text-sm text-primary italic mb-2">{t('birdwatching.registeredBirds.species.umbrellaBird.scientificName')}</p>
                    <p className="text-gray-600 text-sm leading-relaxed line-clamp-2 text-justify">
                      {t('birdwatching.registeredBirds.species.umbrellaBird.description')}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Biodiversity Section */}
        <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-4">
            <h2 className="text-4xl font-semibold text-center mb-16 relative">
              {t('birdwatching.biodiversity.title')}
              <span className="absolute bottom-[-1rem] left-1/2 transform -translate-x-1/2 w-20 h-1 bg-primary" />
            </h2>
            <div className="max-w-4xl mx-auto">
              <p className="text-xl text-gray-700 leading-relaxed text-justify mb-12">
                {t('birdwatching.biodiversity.description')}
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                {/* Amazonian Species */}
                <div className="bg-white p-8 rounded-xl shadow-lg">
                  <h3 className="text-2xl font-semibold text-gray-900 mb-6">{t('birdwatching.biodiversity.amazonianSpecies.title')}</h3>
                  <ul className="space-y-4">
                    {Object.entries(t('birdwatching.biodiversity.amazonianSpecies.species', { returnObjects: true })).map(([key, species]) => (
                      <li key={key} className="flex flex-col">
                        <span className="font-medium text-gray-900">{species.name}</span>
                        <span className="text-sm text-primary italic">{species.scientificName}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Highlighted Birds */}
                <div className="bg-white p-8 rounded-xl shadow-lg">
                  <h3 className="text-2xl font-semibold text-gray-900 mb-6">{t('birdwatching.biodiversity.highlightedBirds.title')}</h3>
                  <ul className="space-y-4">
                    {Object.entries(t('birdwatching.biodiversity.highlightedBirds.species', { returnObjects: true })).map(([key, species]) => (
                      <li key={key} className="flex flex-col">
                        <span className="font-medium text-gray-900">{species.name}</span>
                        <span className="text-sm text-primary italic">{species.scientificName}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Gallery Section */}
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4 max-w-7xl">
            <h2 className="text-3xl font-bold text-center mb-12">{t('birdwatching.gallery.title')}</h2>
            <div id="birdwatching-gallery" className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 pswp-gallery">
              {galleryImages.map((item) => (
                <a 
                  href={item.type === 'image' ? item.largeURL : item.thumbnailURL}
                  data-pswp-width={item.width}
                  data-pswp-height={item.height}
                  data-pswp-srcset={item.srcset}
                  data-pswp-sizes={item.sizes}
                  key={`${item.type}-${item.title}`}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={item.alt || item.title || 'Gallery image'}
                  className="block relative aspect-square overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 group"
                >
                  <img 
                    src={item.thumbnailURL} 
                    srcSet={item.srcset}
                    sizes={item.sizes}
                    alt={item.alt || item.title || 'Gallery image'} 
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" 
                    loading="lazy"
                    decoding="async"
                  />
                  {/* Dynamic Caption for PhotoSwipe */}
                  <span className="pswp-caption-content" style={{display: 'none'}}>
                    <strong>{item.title}</strong><br/>
                    {item.photographer && (<span>{t('gallery.photoCredit')}: {item.photographer}<br/></span>)}
                    {item.description && (<span>{item.description}</span>)}
                  </span>
                  <div className="absolute bottom-0 left-0 right-0 p-2 bg-gradient-to-t from-black/70 to-transparent">
                    <p className="text-white text-xs truncate">{item.title}</p>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </section>

        {/* Special Tour Section */}
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <h2 className="text-4xl font-semibold text-center mb-16 relative">
              {t('birdwatching.specialTour.title')}
              <span className="absolute bottom-[-1rem] left-1/2 transform -translate-x-1/2 w-20 h-1 bg-primary" />
            </h2>
            <div className="max-w-4xl mx-auto">
              <div className="bg-white rounded-xl shadow-lg p-8">
                <div className="mb-8">
                  <h3 className="text-2xl font-semibold text-gray-900 mb-4">{t('birdwatching.specialTour.schedule.title')}</h3>
                  <p className="text-gray-600">{t('birdwatching.specialTour.schedule.departure')}</p>
                </div>
                <div>
                  <h3 className="text-2xl font-semibold text-gray-900 mb-4">{t('birdwatching.specialTour.itinerary.title')}</h3>
                  <ul className="space-y-3">
                    {t('birdwatching.specialTour.itinerary.items', { returnObjects: true }).map((item, index) => (
                      <li key={`itinerary-${index}-${item.substring(0, 20)}`} className="flex items-start">
                        <svg className="w-5 h-5 text-primary mr-3 mt-1" fill="currentColor" viewBox="0 0 20 20">
                          <title>Checkmark</title>
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                        <span className="text-gray-600">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Observation Spots Section */}
        <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-4">
            <h2 className="text-4xl font-semibold text-center mb-16 relative">
              {t('birdwatching.observationSpots.title')}
              <span className="absolute bottom-[-1rem] left-1/2 transform -translate-x-1/2 w-20 h-1 bg-primary" />
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
              {Object.entries(t('birdwatching.observationSpots.spots', { returnObjects: true })).map(([key, spot]) => (
                <div key={key} className="bg-white p-8 rounded-xl shadow-lg">
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">{spot.title}</h3>
                  <p className="text-gray-600 text-justify">{spot.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* References Section */}
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4 max-w-4xl text-center">
            <h2 className="text-4xl font-semibold mb-6">{t('birdwatching.references.title')}</h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-10">
              {t('birdwatching.references.description')}
            </p>
            <div className="flex justify-center gap-6">
              <a 
                href="https://ebird.org/hotspot/L968651"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary hover:bg-primary-dark transition-colors duration-300"
              >
                {t('birdwatching.references.links.ebird')}
              </a>
              <a 
                href="https://datazone.birdlife.org/site/factsheet/rio-claro"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary hover:bg-primary-dark transition-colors duration-300"
              >
                {t('birdwatching.references.links.birdlife')}
              </a>
              <a 
                href="https://www.wikiaves.com.br/municipio_5107305"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary hover:bg-primary-dark transition-colors duration-300"
              >
                {t('birdwatching.references.links.wikiaves')}
              </a>
              <a 
                href="https://www.savebrasil.org.br/beneficios-amigos-save"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary hover:bg-primary-dark transition-colors duration-300"
              >
                {t('birdwatching.references.links.save')}
              </a>
            </div>
          </div>
        </section>

        {/* SAVE Brasil Section */}
        <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-4 max-w-4xl">
            <h2 className="text-4xl font-semibold text-center mb-16 relative">
              {t('birdwatching.saveBrasil.title')}
              <span className="absolute bottom-[-1rem] left-1/2 transform -translate-x-1/2 w-20 h-1 bg-primary" />
            </h2>
            <div className="text-lg text-gray-700 leading-relaxed mb-12 text-center">
              <p className="mb-8">{t('birdwatching.saveBrasil.partnership')}</p>
              <a 
                href="https://www.savebrasil.org.br/beneficios-amigos-save"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-lg font-semibold rounded-md text-white bg-primary hover:bg-primary-dark transition-colors duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
              >
                {t('birdwatching.saveBrasil.button')}
              </a>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Birdwatching;